export const createPlaybook = `
    mutation createPlaybook($input: CreatePlaybookInput!) {
        createPlaybook(input:$input) {
            id
            name
            displayName
            description
            stateMachineArn
            inputSchema
            category
            status
            createdByUsername
            created
    }
}`;

export const updatePlaybook = `
    mutation updatePlaybook($input: UpdatePlaybookInput!) {
        updatePlaybook(input:$input){
            id
            name
            displayName
            description
            stateMachineArn
            inputSchema
            category
            status
            createdByUsername
            created
            updated
        }
}`;

export const deletePlaybook = `
    mutation deletePlaybook($input: DeletePlaybookInput!) {
        deletePlaybook(input:$input) {
            id
        }
}`;

// FNP-1011: recreate a playbook from an exported definition.
//
// ⚠️ Admin-only on the API (@aws_cognito_user_pools with the admin group, and
// deliberately NOT @aws_iam). It writes the playbook and every phase and step
// in ONE TransactWriteItems, so a failure creates nothing.
//
// The counts come back so the console can report what was ACTUALLY created
// rather than echoing what the file claimed.
export const importPlaybook = `
    mutation importPlaybook($input: ImportPlaybookInput!) {
        importPlaybook(input:$input) {
            id
            name
            phaseCount
            stepCount
        }
}`;
